import { newSpecPage } from '@stencil/core/testing';
import { ChapelVideo } from '../chapel-video';

describe('chapel-video', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [ChapelVideo],
      html: `<chapel-video></chapel-video>`,
    });
    expect(page.root).toEqualHtml(`
      <chapel-video>
        <mock:shadow-root>
          <slot></slot>
        </mock:shadow-root>
      </chapel-video>
    `);
  });
});
